
import Typography from '@library/components/Atoms/Typography/Typography.vue'
export default {
  name: 'GDPRPanel',
  props: {
    labels: {
      type: Object,
      required: true,
      default: () => {}
    },
    data: {
      type: Object,
      required: true,
      default: () => {}
    },
    opened: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  components: {
    Typography
  },
  methods: {
    modalPanelGDPRClick() {
      document.querySelectorAll('.gdpr-panel-modal-link').forEach(item => {
        item.addEventListener('click', async event => {
          const payload = {
            modalPageId: event.target.dataset.pageid,
            anchor: event.target.dataset.anchorid
          }
          this.$emit('openGDPRModal', payload)
        })
      })
    },
    closePanel() {
      this.$emit('closePanel')
    },
    bulletText(text) {
      let textHtml = ''
      if (text.title) {
        textHtml = `<strong>${text.title}</strong> ${text.body}`
      } else {
        textHtml = text.body
      }
      return textHtml
    }
  },
  mounted() {
    this.modalPanelGDPRClick()
  }
}
